import { Download, X } from "lucide-react";

export function AndroidInstallPrompt({ onInstall, onDismiss, canInstall }) {
  if (!canInstall) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 animate-in fade-in slide-in-from-bottom-4 duration-300 z-50">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onDismiss}
      />

      {/* Card */}
      <div className="relative bg-gradient-to-br from-blue-50 to-indigo-50 border-t-2 border-indigo-300 shadow-2xl">
        <div className="max-w-md mx-auto px-6 py-5">
          {/* Header */}
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-3 flex-1">
              <div className="bg-indigo-100 rounded-lg p-2.5 flex-shrink-0">
                <Download className="w-5 h-5 text-indigo-600" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 text-sm">
                  Install diet-reg
                </h3>
                <p className="text-xs text-gray-600 mt-0.5">
                  Quick access on your home screen
                </p>
              </div>
            </div>

            <button
              onClick={onDismiss}
              className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0 ml-2"
              aria-label="Dismiss"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          {/* Description */}
          <p className="text-xs text-gray-700 mb-4 leading-relaxed">
            Get instant access to your nutrition tracking without opening a
            browser. No app store needed!
          </p>

          {/* CTA Buttons */}
          <div className="flex gap-2">
            <button
              onClick={onInstall}
              className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors text-sm font-semibold shadow-sm hover:shadow-md"
            >
              Install Now
            </button>
            <button
              onClick={onDismiss}
              className="flex-1 bg-white hover:bg-gray-50 border border-gray-200 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition-colors text-sm"
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
